import styled from 'styled-components';

export const SubscriptionFullPaymentInfoStyles = styled.div`
  color: var(--text-color-black);

  &.soldOut {
    color: #3c3c4399;
  }

  .type-label {
    display: flex;
    align-items: center;
    color: inherit;

    span {
      font-size: 11px;
      line-height: 16px;
      font-weight: 500;
      padding: 1px 8px;
      background: #3c3c4399;
      color: #fff;
      border-radius: 5px;
      margin-left: 8px;
      text-transform: uppercase;
    }
  }

  .local-full-prices {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    color: inherit;

    &-without-sale {
      text-decoration: line-through;
    }
  }
`;

export const SubscriptionPerDayPaymentInfoStyles = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: var(--text-color-black);

  &.soldOut {
    color: #3c3c4399;
  }

  .local-without-sale {
    text-decoration: line-through;
  }

  .local-base {
    color: inherit;
  }
`;
